import { render, staticRenderFns } from "./SelecaoProdutor.vue?vue&type=template&id=65085ef1"
import script from "./SelecaoProdutor.vue?vue&type=script&lang=js"
export * from "./SelecaoProdutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports